export default __webpack_public_path__ + "static/media/Comp 2_00037.20315b34.png";